import getReturnPointsListDB from './return-points-service';

export default getReturnPointsListDB;
